import { Box, type BoxProps, Button, Flex, HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Logo } from '@/components';
import { IconPlus } from '@/components/Icons';
import { useGetAccountQuery } from '@/features/auth/useAuthQueries';
import { NavBarLanguageMenu } from '@/features/common';
import { INTERVIEW_NAV_BAR_HEIGHT } from '@/features/interview';

import { ACCOUNT_PATH } from '../account/constants';
import { CoachNavBarAccountMenu } from '../coach';

export const CVAnalysisResultNavBar = (props: BoxProps) => {
  const { t } = useTranslation(['cv']);
  const navigate = useNavigate();
  const { data, isLoading } = useGetAccountQuery();

  const { name, surname, email, profileImage } = data ?? {};

  const fullName = `${name ?? ''} ${surname ?? ''}`.trim();

  return (
    <Box {...props}>
      <Flex
        zIndex="sticky"
        position="fixed"
        top="0"
        insetStart="0"
        insetEnd="0"
        color="gray.50"
        align="center"
        justify="center"
        pt="safe-top"
        px="4"
        h={INTERVIEW_NAV_BAR_HEIGHT}
        bg="white"
        boxShadow="layout"
        borderBottom="1px solid transparent"
      >
        <Flex
          grow={1}
          align="center"
          justify="space-between"
          maxW="container.xl"
        >
          <Box mx={0}>
            <Logo />
          </Box>

          <HStack alignItems="center">
            <CoachNavBarAccountMenu
              logoutPath={`/logout?redirect=${ACCOUNT_PATH}/login`}
              isLoading={isLoading}
              email={email ?? ''}
              name={fullName}
              profileImage={profileImage ?? ''}
            />
            <NavBarLanguageMenu />
            <Button
              type="submit"
              leftIcon={<IconPlus />}
              variant="@primary"
              w="full"
              px={{ base: 2, sm: 4 }}
              fontSize={{ base: 13, sm: 16 }}
              onClick={() => navigate('/cv/new')}
            >
              {t('cv:new.AddNewCV')}
            </Button>
          </HStack>
        </Flex>
      </Flex>
      <Box h={INTERVIEW_NAV_BAR_HEIGHT} />
    </Box>
  );
};
